import Questions from '../../../Common/Questions/Questions';
import AboutUs from '../AboutUs/AboutUs';
import ClientTestimonial from '../Client/ClientTestimonial';
import FreeClass from '../FreeClass/FreeClass';
import Gallery from '../Gallery/Gallery';

const AboutMain = () => {
  return (
    <div>
      <AboutUs></AboutUs>
      <FreeClass></FreeClass>
      <Gallery />
      <ClientTestimonial></ClientTestimonial>
      <Questions></Questions>
    </div>
  );
};

export default AboutMain;
